<template>
    <div class="table-container" ref="tableContainer">
        <table>
            <thead>
                <tr>
                    <th class="number-column">#</th>
                    <th v-for="dataset in datasets" :key="dataset.label">
                        {{ formatHeaderLabel(dataset.label) }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(label, index) in labels" :key="label + index">
                    <td class="number-column">{{ index + 1 }}</td>
                    <td v-for="dataset in datasets" :key="dataset.label + index">
                        {{ dataset.data[index] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'DataTable',
    props: {
        labels: {
            type: Array,
            required: true
        },
        datasets: {
            type: Array,
            required: true
        }
    },
    methods: {
        formatHeaderLabel(label) {
            if (!label || typeof label !== 'string') {
                return label
            }
            
            if (label.includes(' ')) {
                return label
            }
            
            const withSpaces = label.replace(/([a-z])([A-Z])/g, '$1 $2')
            
            const words = withSpaces.split(' ')
            const formatted = words.map((word, index) => {
                if (index === 0) {
                    return word
                } else {
                    return word.charAt(0).toLowerCase() + word.slice(1)
                }
            })
            
            return formatted.join(' ')
        },
        downloadTableAsXLS() {
            if (!this.$refs.tableContainer) return

            const headerCells = ['#', ...this.datasets.map(dataset => this.formatHeaderLabel(dataset.label))]

            const headerRow = headerCells.map((cell, index) => {
                const style = index === 0 ? 'text-align: center; width: 50px;' : 'text-align: left;'
                return `<th style="${style}">${cell}</th>`
            }).join('')

            const dataRows = this.labels
                .map((label, index) => {
                    const cells = [index + 1, ...this.datasets.map(dataset => dataset.data[index])]

                    return cells.map((cell, cellIndex) => {
                        const style = cellIndex === 0 ? 'text-align: center;' : 'text-align: left;'
                        return `<td style="${style}">${cell}</td>`
                    }).join('')
                })
                .join('</tr><tr>')

            const tableHTML = `
        <table style="border-collapse: collapse; width: 100%;">
          <thead><tr>${headerRow}</tr></thead>
          <tbody><tr>${dataRows}</tr></tbody>
        </table>
      `

            const xls = `
        <html xmlns:x='urn:schemas-microsoft-com:office:excel'>
        <head></head>
        <body>${tableHTML}</body>
        </html>
      `

            const blob = new Blob([xls], { type: 'application/vnd.ms-excel' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = `${this.$t('chartTable')}.xls`
            link.click()
        }
    }
}
</script>

<style scoped>
.table-container {
    margin-top: 10px;
    overflow-y: auto;
    overflow-x: auto;
    max-height: 350px;
    width: 100%;
    color: black;
}

table {
    width: 100%;
    table-layout: auto;
    border-collapse: collapse;
    min-width: 100%;
}

th,
td {
    word-break: break-word;
    overflow: hidden;
    white-space: nowrap;
    font-size: 0.95em;
    padding: 4px 8px;
    text-align: left;
    min-width: fit-content;
}

th {
    white-space: nowrap;
    word-wrap: normal;
    max-width: none;
}

.number-column {
    text-align: center !important;
    width: 50px;
    min-width: 50px;
    max-width: 50px;
}

@media (max-width: 1200px) {
    th,
    td {
        font-size: 0.85em;
    }
}

@media (max-width: 800px) {
    th,
    td {
        font-size: 0.75em;
    }
    
    th {
        white-space: nowrap;
        word-wrap: normal;
    }
}
</style>
